export const langs: string[] = [
  'en',
  //   'es',
  'kr',
  'jp',
  // 'de',
  //   'pl',
]
